import api from "./api";

const attachAuth = (config = {}, token) => {
  if (!token) return config;
  return {
    ...config,
    headers: { ...(config.headers || {}), Authorization: `Bearer ${token}` },
  };
};

const uploadService = {
  cloudinarySignature: (payload = {}, token) =>
    api.post("/uploads/cloudinary-signature", payload, attachAuth({}, token)),
};

export default uploadService;
